import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { SITE_NAME } from "./config/site";

const languageMap = {
  da: "Dansk",
  de: "Deutsch",
  en: "English",
  es: "Español",
  fr: "Français",
  it: "Italiano",
  nl: "Nederlands",
  pl: "Polski",
  pt: "Português",
  fi: "Suomi",
  sv: "Svenska",
  el: "Ελληνικά",
};

const languages = Object.entries(languageMap).map(([code, nativeName]) => ({
  code,
  nativeName,
}));

i18n.languageMap = languageMap;
i18n.allLanguages = languages;

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ["cookie", "localStorage", "navigator"],
      caches: ["cookie"],
      convertDetectedLanguage: (lng) =>
        String(lng || "en")
          .replace(/_/g, "-")
          .toLowerCase(),
    },
    fallbackLng: "en",
    nonExplicitSupportedLngs: true,
    supportedLngs: languages.map((l) => l.code),
    ns: ["translations"],
    defaultNS: "translations",
    debug: false,
    useSuspense: true,
    interpolation: {
      escapeValue: false,
      defaultVariables: {
        siteName: SITE_NAME,
      },
    },
    backend: {
      loadPath: "/locales/{{lng}}/translations.json",
    },
  });

export default i18n;
